import React from 'react';
import "./ServiceCard.css"
import { Card, Row, Col } from 'react-bootstrap';
import IllustrationCard from '../../../common_components/illustrationCard/IllustrationCard';
import { Link } from 'react-router-dom';

const ServiceCard = ({ title, description, features, price, imageSrc, baseLink }) => {
  return (
    <>
    <Link to={baseLink}>
    <Card className="service-pricing-card h-100">
      <Card.Body className="d-flex flex-column justify-content-between p-2">
        <div>
          {/* Upper Row: Text Details & Illustration */}
          <Row className="align-items-start g-3">
            <Col xs={7} sm={7} className="pe-0">
              <h3 className="card-title-text">{title}</h3>
              <p className="card-description-text">{description}</p>
              
              {/* Features Checklist */}
              <ul className="card-features-list">
                {features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <span className="checkmark">✓</span> {feature}
                  </li>
                ))}
              </ul>
            </Col>
            
            {/* Right side Illustration Box */}
            <Col xs={5} sm={5} className="">
              <IllustrationCard imageSrc={imageSrc} title={title} />
            </Col>
          </Row>
        </div>

        {/* Footer Row: Pricing & Action Trigger */}
        <div className="card-footer-action d-flex align-items-end justify-content-between mt-4">
          <div>
            <span className="price-label">Starting @</span>
            <div className="price-value">₹{price}</div>
          </div>
          <div className="arrow-action-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>
          </div>
        </div>
      </Card.Body>
    </Card>
    </Link>
    </>
  );
};

export default ServiceCard;